import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { Backdrop, CircularProgress } from '@mui/material'
import { Context } from '../context/AuthContext'
import { usePermissoes } from '../permissions'

/**
 * Bloqueia a rota quando o usuário não está autenticado ou não tem a permissão
 * exigida — as mesmas chaves cadastradas no SSO.
 *
 * A verificação aqui evita que a pessoa entre numa tela que só mostraria erro;
 * quem realmente decide é a API, que aplica o mesmo catálogo em cada rota.
 */
export const PrivateRoute = ({ permissao, children }) => {
  const { authenticated, loading } = useContext(Context)
  const { pode } = usePermissoes()

  if (loading) {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open>
        <CircularProgress color="inherit" />
      </Backdrop>
    )
  }

  if (!authenticated) {
    return <Navigate to="/Login" replace />
  }

  if (!permissao) {
    return children
  }

  const exigidas = Array.isArray(permissao) ? permissao : [permissao]
  return pode(...exigidas) ? children : <Navigate to="/Aviso" replace />
}

export default PrivateRoute
